import React, { useState, useEffect } from "react";
import {
  get,
  post,
  put,
  deleteRequestV2,
} from "../../api/usersModule/httpClient";
import { useDebounce } from "../../hooks/useDebounce";
import { CDBModal } from "cdbreact";
import { ModalDispatchOrders } from "../Modals/ModalDispatchOrders";
import { ModalDispatch } from "../Modals/ModalDispatch";
import { ModalDispatchOrdersReport } from "../Modals/ModalDispatchOrdersReport";
import { LargeCard } from "../../Components/Cards/LargeCard";
import swal from "sweetalert";
import { useNotificationsContext } from "../../utils/Contexts/NotificationsContext";
import { useUserContext } from "../../utils/Contexts/UserContext";
import Swal from "sweetalert2";

const usersheaders = [
  "ID de despacho",
  "Código Proveedor",
  "Proveedor",
  "Fecha y hora de entrega estimada",
  "Descripción",
  "Fecha de modificación",
  "Usuario",
  "/dispatch",
];

const defaultFormData = {
  IDDispatch: "",
  Nit: "",
  QuantityShipped: 0,
  DeliveryTime: "",
  LicensePlate: "",
  DispatchDescription: "",
  selectedInitialDate: "",
  selectedFinalDate: "",
  selectedProvider: "",
};

export const CrudDispatchOrders = ({
  userName,
  permissions,
  project,
  codeSap,
}) => {
  const [data, setData] = useState([]);
  const [state, setState] = useState({
    modal5: false,
    modal6: false,
    modal7: false,
  });
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);
  const [pressedButton, setPressedButton] = useState("");
  const [action, setAction] = useState("");
  const [skus, setSkus] = useState([]);
  const [providers, setProviders] = useState([]);
  const [initialRender, setInitialRender] = useState(true);
  const [initialLoad, setinitialLoad] = useState(false);
  const [changePage, setChangePage] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedSkus, setSelectedSkus] = useState([]);
  const [nameProvider, setNameProvider] = useState([]);
  const [dispatchedskus, setDispatchedskus] = useState([]);

  const [formData, setFormData] = useState({
    ...defaultFormData,
    user: userName,
  });

  const getData = async (search, statusPage) => {
    try {
      setLoading(true);
      let response;
      if (codeSap !== "" && codeSap !== null && codeSap !== undefined) {
        response = await get(
          `/dispatchOrders?page=${statusPage}&search=${search}&CodeSap=${codeSap}&limit=${itemsPerPage}`
        );
      } else {
        response = await get(
          `/dispatchOrders?page=${statusPage}&search=${search}&Nit=${project}&limit=${itemsPerPage}`
        );
      }
      if (response && response.answer) {
        setTotalItems(response.pagination.totalItems);
      } else {
        setTotalItems(0);
      }
      setData(response ? response.items : []);
      setLoading(false);
    } catch (error) {
      console.error("Error al obtener los datos:", error);
      setData([]);
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al obtener los datos. Por favor, inténtalo de nuevo más tarde.",
        confirmButtonColor: "#146284",
      });
    }
  };

  const getDispatchOrder = async (iDDispatch, dispatchOrderSKU) => {
    try {
      const response = await get(
        `/dispatchOrders?IDDispatch=${iDDispatch.split("/*-/")[0]}&Nit=${
          iDDispatch.split("/*-/")[1]
        }&dispatchOrderSKU=${dispatchOrderSKU}`
      );
      if (dispatchOrderSKU) {
        setDispatchedskus(response.items);
      } else {
        setFormData(response.items[0]);
      }
    } catch (error) {
      setFormData([]);
      console.error("Error al obtener la orden de despacho:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al obtener la orden de despacho. Por favor, inténtalo de nuevo más tarde.",
        confirmButtonColor: "#146284",
      });
    }
  };

  const getProviders = async (numberToggle) => {
    Swal.fire({
      title: "Cargando",
      text: "Espere un momento por favor...",
      willOpen: () => {
        Swal.showLoading();
      },
      showConfirmButton: false,
      allowOutsideClick: () => !Swal.isLoading(),
      allowEscapeKey: () => !Swal.isLoading(),
    });

    try {
      const response = await get(`/projects?Nit=${project}&list=${true}`);
      if (String(project) !== "1") {
        formData.selectedProvider = String(project);
      } else {
        formData.selectedProvider = "";
      }
      setProviders(response.items);
      toggle(numberToggle)();
    } catch (error) {
      console.error("Error fetching module:", error);
      Swal.fire(
        "Error",
        "Ocurrió un error al cargar los proveedores. Por favor, intente de nuevo más tarde.",
        "error"
      );
    } finally {
      Swal.close();
    }
  };

  const getSku = async (nit) => {
    try {
      const response = await get(`/skus?Nit=${nit}&Lista=True`);
      setSkus(response.items);
    } catch (error) {
      console.error("Error al obtener los SKUs:", error);
      setSkus([]);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al obtener los SKUs. Por favor, inténtalo de nuevo más tarde.",
        confirmButtonColor: "#146284",
      });
    }
  };

  const getReportDispatchOrders = async (nitReport) => {
    const { selectedInitialDate, selectedFinalDate, selectedProvider } =
      formData;

    const { value: generateReport } = await Swal.fire({
      title: "¿Desea generar el reporte?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#146284",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, generar",
      cancelButtonText: "Cancelar",
    });

    if (generateReport) {
      Swal.fire({
        title: "Generando Reporte",
        text: "Por favor, espere...",
        icon: "info",
        allowOutsideClick: false,
        showCancelButton: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });

      const response = await get(
        `/dispatchOrders?Nit=${nitReport}&reportDispatchOrders=${true}&sort_by=d.CreateDate&selectedInitialDate=${
          selectedInitialDate || ""
        }&selectedFinalDate=${selectedFinalDate || ""}&selectedProvider=${
          selectedProvider || ""
        }`
      );

      if (response.answer) {
        Swal.close();
        window.open(response.url, "_blank");
      } else {
        Swal.close();
        Swal.fire({
          icon: "error",
          title: "¡Oops!",
          text: "Hubo un error al generar el reporte. Es posible que no se tengan datos disponibles para su generación.",
          confirmButtonColor: "#146284",
        });
      }
    }
  };

  const closeModal = (nr) => {
    const modalNumber = "modal" + nr;
    setState({ ...state, [modalNumber]: !state[modalNumber] });
  };

  const toggle = (nr) => () => {
    const modalNumber = "modal" + nr;
    setState((prevState) => ({
      ...prevState,
      [modalNumber]: !prevState[modalNumber],
    }));
  };

  const handleChange = (targets) => {
    targets.forEach((target) => {
      const { id, value } = target;
      setFormData((prevData) => ({ ...prevData, [id]: value }));
    });
  };

  const convertDataToArray = () => {
    try {
      return data.map((item) => {
        const fechaTransformada =
          item.DeliveryTime && !isNaN(new Date(item.DeliveryTime))
            ? new Date(item.DeliveryTime).toLocaleString("en-US", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
              })
            : "No proporcionado";

        let modificationDate;

        if (typeof item.ModificationDate === "boolean") {
          modificationDate = item.ModificationDate
            ? "No proporcionado"
            : "Proporcionado";
        } else if (isNaN(new Date(item.ModificationDate))) {
          modificationDate = "No proporcionado";
        } else {
          modificationDate = new Date(item.ModificationDate).toLocaleString(
            "en-US",
            {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
            }
          );
        }

        return [
          item.IDDispatch.toUpperCase(),
          item.Nit.toUpperCase(),
          item.ProjectName.toUpperCase(),
          fechaTransformada.toString(),
          item.DispatchDescription.toUpperCase(),
          modificationDate,
          item.User.split(" ")
            .map(
              (word) =>
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            )
            .join(" "),
        ];
      });
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  const handleSubmit = () => {
    const requiredFields = ["IDDispatch", "Nit", "DeliveryTime"];

    const missingFields = requiredFields.filter((field) => !formData[field]);

    if (missingFields.length > 0) {
      swal("Error", "Por favor, rellene todos los campos", "error");
      setLoading(false);
      return false;
    }

    return true;
  };

  const saveData = async () => {
    Swal.fire({
      title: `${
        action === "create" ? "Creando" : "Actualizando"
      } Orden de Despacho`,
      text: "Por favor, espere...",
      icon: "info",
      allowOutsideClick: false,
      showCancelButton: false,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading();
      },
    });

    const {
      IDDispatch,
      QuantityShipped,
      DeliveryTime,
      DispatchDescription,
      Nit,
    } = formData;
    const User = userName || "Admin";

    try {
      const response = await (action === "create" ? post : put)(
        "/dispatchOrders",
        {
          IDDispatch: IDDispatch.toUpperCase(),
          QuantityShipped,
          DeliveryTime,
          DispatchDescription: DispatchDescription.toUpperCase(),
          User: User.split(" ")
            .map(
              (word) =>
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            )
            .join(" "),
          Nit: Nit.toUpperCase(),
        },
        "",
        true
      );

      if (!response.answer) {
        Swal.close();
        swal(
          "Error",
          `No se pudo ${
            action === "create" ? "crear" : "actualizar"
          } la orden de despacho. Por favor, revise la información (Puede deberse, a que ya se tiene un registro con el mismo ID).`,
          "error"
        );
      } else if (response.answer) {
        if (action === "create") {
          await getSku(Nit);
        }
        setDispatchedskus([]);
        setNameProvider(`${IDDispatch.toUpperCase()}/*-/${Nit.toUpperCase()}`);
        Swal.close();
        Swal.fire({
          icon: "success",
          title: `Orden de despacho ${
            action === "create" ? "creada" : "actualizada"
          }`,
          text: `La orden de despacho se ${
            action === "create" ? "creó" : "actualizó"
          } correctamente.${
            action === "create"
              ? " Ahora debe seguir con la carga de SKUS para la orden de despacho."
              : ""
          }`,
          confirmButtonText: "Entendido",
          confirmButtonColor: "#146284",
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then((result) => {
          closeModal(6);
          if (action === "create") {
            if (result.isConfirmed) {
              setinitialLoad(true);
              toggle(5)();
            }
          }
        });
      }

      getData("", 1);
    } catch (error) {
      Swal.close();
      console.error(
        `Error al ${
          action === "create" ? "crear" : "actualizar"
        } la documentación:`,
        error
      );
    }
  };

  const loadSkus = async (codeSapQuantityData) => {
    if (codeSapQuantityData.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Orden de despacho vacía",
        text: "La orden de despacho debe tener al menos un SKU asociado.",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#146284",
      });
      return false;
    }
    Swal.fire({
      title: "Cargando Skus",
      text: "Por favor, espere...",
      icon: "info",
      allowOutsideClick: false,
      showCancelButton: false,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading();
      },
    });
    const User = userName || "Admin";

    try {
      const response = await put("/dispatchOrders", {
        codeSapQuantityData: codeSapQuantityData,
        User: User.split(" ")
          .map(
            (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
          )
          .join(" "),
      });

      Swal.close();
      if (!response.answer) {
        swal(
          "Error",
          "No se pudo cargar SKUs a la orden de despacho. Por favor, revise la información.",
          "error"
        );
      } else if (response.answer) {
        toggle(5)();
        swal(
          `Orden de despacho ${action === "create" ? "creada" : "actualizada"}`,
          `La orden de despacho se ${
            action === "create" ? "creó" : "actualizó"
          } correctamente.`,
          "success"
        );
      }

      getData("", 1);
    } catch (error) {
      Swal.close();
      console.error(
        `Error al ${
          action === "create" ? "crear" : "actualizar"
        } la documentación:`,
        error
      );
    }
  };

  const deleteDispatch = async () => {
    try {
      const body = JSON.stringify({
        IDDispatch: formData.IDDispatch,
        Nit: formData.Nit,
      });

      const confirmDelete = await Swal.fire({
        title: "Confirmar Eliminación de la Orden de Despacho",
        text: "Esta acción eliminará de manera permanente la Orden de Despacho seleccionada, así como cualquier dato relacionado. ¿Está seguro de que desea proceder?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#146284",
        cancelButtonColor: "#EF4444",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      });

      if (confirmDelete.isConfirmed) {
        Swal.fire({
          title: "Eliminando Orden de Despacho",
          text: "Por favor, espere...",
          icon: "info",
          allowOutsideClick: false,
          showCancelButton: false,
          showConfirmButton: false,
          willOpen: () => {
            Swal.showLoading();
          },
        });

        await deleteRequestV2("dispatchOrders", body, true);

        Swal.close();

        toggle(6)();
        getData("", 1);
      }
    } catch (error) {
      console.error("Error al eliminar la Orden de Despacho:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al eliminar la Orden de Despacho. Por favor, inténtalo de nuevo más tarde.",
        confirmButtonColor: "#146284",
      });
      getData("", 1);
    }
  };

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (initialLoad) {
        const confirmationMessage =
          "Estás intentando salir de la página. ¿Estás seguro?";
        event.returnValue = confirmationMessage;
        return confirmationMessage;
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [initialLoad]);

  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
      return;
    }

    if (!changePage) {
      getData(debouncedSearch, page);
    } else {
      setChangePage(false);
    }
  }, [page, initialRender]);

  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
      return;
    }
    getData(debouncedSearch, 1);
    setChangePage(true);
    setPage(1);
  }, [debouncedSearch]);

  useEffect(() => {
    getData(debouncedSearch, 1);
    setChangePage(true);
    setPage(1);
  }, [itemsPerPage]);

  useEffect(() => {
    switch (pressedButton.split(",")[0]) {
      case "create":
        if (permissions["Crear"]) {
          setAction("create");
          setFormData(defaultFormData);
          getProviders(6);
        } else {
          swal({
            title: "Error",
            text: "No tiene permisos para crear un despacho",
            icon: "error",
            buttons: ["", "Aceptar"],
          });
        }
        break;
      case "edit":
        if (permissions["Editar"]) {
          setAction("edit");
          getDispatchOrder(pressedButton.split(",")[1], false);
          getProviders(6);
        } else {
          swal({
            title: "Error",
            text: "No tiene permisos para editar un despacho",
            icon: "error",
            buttons: ["", "Aceptar"],
          });
        }
        break;
      case "delete":
        if (permissions["Eliminar"]) {
          deleteDispatch(pressedButton.split(",")[1]);
        } else {
          swal({
            title: "Error",
            text: "No tiene permisos para borrar un despacho",
            icon: "error",
            buttons: ["", "Aceptar"],
          });
        }
        break;
      case "monthlyReport":
        getProviders(7);
        //getReportDispatchOrders(project);
        break;
      case "downloadReport":
        getReportDispatchOrders(project);
        break;
      case "stateDispatch":
        setDispatchedskus([]);
        async function fetchDataAndSet() {
          Swal.fire({
            title: "Cargando datos",
            text: "Por favor, espere...",
            icon: "info",
            allowOutsideClick: false,
            showCancelButton: false,
            showConfirmButton: false,
            willOpen: () => {
              Swal.showLoading();
            },
          });
          setinitialLoad(false);
          try {
            const skuPromise = getSku(
              pressedButton.split(",")[1].split("/*-/")[1]
            );
            const dispatchOrderPromise = getDispatchOrder(
              pressedButton.split(",")[1],
              true
            );

            await Promise.all([skuPromise, dispatchOrderPromise]);

            setNameProvider(pressedButton.split(",")[1]);
            toggle(5)();
            Swal.close();
          } catch (error) {
            Swal.close();
            console.error("Error:", error);
          }
        }

        fetchDataAndSet();
        break;
      case "loadSkus":
        const codeSapQuantityData = [];

        selectedSkus.forEach((sku) => {
          codeSapQuantityData.push({
            CodeSap: sku.CodeSap,
            quantity: parseFloat(sku.quantity),
            code: nameProvider.split("/*-/")[1],
            IDDispatch: nameProvider.split("/*-/")[0],
          });
        });
        const quantityGreaterThanZero = codeSapQuantityData.every(
          (item) => item.quantity > 0
        );

        if (quantityGreaterThanZero) {
          loadSkus(codeSapQuantityData);
        } else {
          Swal.fire({
            icon: "warning",
            title: "Inventario de SKU insuficiente",
            text: "El inventario de al menos uno de los SKU en la orden de despacho es igual a 0, lo cual no está permitido.",
            confirmButtonText: "Entendido",
            confirmButtonColor: "#146284",
          });
        }
        break;
      case "refresh":
        getData("", page);
        break;
      case "closeModal":
        if (state.modal6) {
          closeModal(6);
        }
        if (state.modal7) {
          closeModal(7);
        }
        if (state.modal5) {
          closeModal(5);
        }
        break;
      case "submitModal":
        const success = handleSubmit();
        if (success) {
          saveData();
        }
        break;
      default:
        break;
    }
    setPressedButton("");
  }, [pressedButton]);

  return (
    <>
      <LargeCard
        name="Despacho"
        headers={usersheaders}
        loading={loading}
        data={convertDataToArray()}
        totalItems={totalItems}
        customTable={false}
        setPage={setPage}
        page={page}
        setChangePage={setChangePage}
        setPressedButton={setPressedButton}
        setSearch={setSearch}
        cState={true}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
      />
      <CDBModal isOpen={state.modal6} toggle={() => {}}>
        <ModalDispatchOrders
          action={action}
          setPressedButton={setPressedButton}
          formData={formData}
          closeModal={closeModal}
          handleChange={handleChange}
          providers={providers}
        />
      </CDBModal>
      <CDBModal isOpen={state.modal7} toggle={() => {}}>
        <ModalDispatchOrdersReport
          action={action}
          setPressedButton={setPressedButton}
          formData={formData}
          closeModal={closeModal}
          handleChange={handleChange}
          providers={providers}
          providerState={project}
        />
      </CDBModal>
      <CDBModal isOpen={state.modal5} toggle={() => {}} className="modal-xl">
        <ModalDispatch
          action={action}
          setPressedButton={setPressedButton}
          skus={skus}
          selectedSkus={selectedSkus}
          setSelectedSkus={setSelectedSkus}
          nameProvider={nameProvider}
          dispatchedskus={dispatchedskus}
          initialLoad={initialLoad}
        />
      </CDBModal>
    </>
  );
};
